"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isObjectURL(url) {
    return url.startsWith('blob');
}
exports.isObjectURL = isObjectURL;
//# sourceMappingURL=types.js.map